export const SET_TOTAL_ROWS = "SET_TOTAL_ROWS";
export const SET_TOTAL_COLS = "SET_TOTAL_COLS";
export const SET_TOTAL_MINES = "SET_TOTAL_MINES";
export const SET_BOARD_TIMESTAMP = "SET_BOARD_TIMESTAMP";
export const SET_IS_REVEAL_MODE = "SET_IS_REVEAL_MODE";
